import React from "react";
import classes from "../homepage/Landing.module.css";
import img from "../../assets/sk_logo_crop.png";
import img2 from "../../assets/Text_BattleMechs.png";
import { Link } from "react-router-dom";

const Landing: React.FC = () => {
  return (
    <div className={classes["landing-wrapper"]}>
      <div className={classes["landing-inner-wrapper"]}>
        <div
          data-aos="slide-down"
          data-aos-easing="ease-out"
          className={classes["landing-content-wrapper"]}
        >
          <img className={classes["logo1"]} src={img} alt="" />
          <img
            className={classes["logo2"]}
            data-aos="fade-down"
            data-aos-easing="ease-out"
            data-aos-delay="1500"
            data-aos-speed="2000"
            src={img2}
            alt=""
          />
          <div
            data-aos="flip-right"
            data-aos-easing="ease-out"
            data-aos-delay="2500"
            data-aos-speed="1500"
            className={classes["navbar-paginatiion-links"]}
          >
            <Link to="/#">
              <div className={classes["links-icon"]}>
                <a
                  href="https://www.magiceden.io/marketplace/spacekitties"
                  target="_blank"
                  rel="noreferrer"
                >
                  Space Kitties on MagicEden
                </a>
              </div>
            </Link>
            <Link to="/game">
              <div
                className={classes["links-icon"]}
                style={{ marginLeft: "1rem" }}
              >
                Battle Mech Game
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
